import * as moment from 'moment';
import { Nav } from "react-bootstrap";
import { NavItemWrapper, NavWrapper } from './styles';

interface IProps {
    tabKey: string,
    subTabKey: string,
    id: string
}

const AdminReportsNav = (props: IProps) => {
    const hrefPrefix = '/admin/reports';

    return (
        <NavWrapper verticalAlign='center' minTabWidth='85' fontSize='12px' style={{ display: 'block' }}>
            <Nav bsStyle='tabs' className='center-tabs' activeKey={props.tabKey}>
                <NavItemWrapper active={props.tabKey == 'DASHBOARD'} href={hrefPrefix + '/dash-board/summary'}>
                    <div>DASHBoard</div>
                </NavItemWrapper>

                <NavItemWrapper active={props.tabKey == 'ALL-CENTERS'} href={hrefPrefix + '/all-centers'}>
                    All Centers
                </NavItemWrapper>
            </Nav>

            {props.tabKey == 'DASHBOARD' && (
                <div style={{ padding: '20px 10px', backgroundColor: 'white' }}>
                    <Nav bsStyle='pills' className='center-pills'>
                        <NavItemWrapper active={props.subTabKey == 'SUMMARY'} href={hrefPrefix + '/dash-board/summary'}>
                            CR1
                        </NavItemWrapper>

                        <li role='presentation' className='divider'><span>|</span></li>

                        <NavItemWrapper active={props.subTabKey == "VOLUME"} href={hrefPrefix + '/dash-board/volume'}>
                            Volume
                        </NavItemWrapper>

                        <li role='presentation' className='divider'><span>|</span></li>

                        <NavItemWrapper active={props.subTabKey == 'CONTACTS'} href={hrefPrefix + '/dash-board/contacts'}>
                            Contacts
                        </NavItemWrapper>

                        <li role='presentation' className='divider'><span>|</span></li>

                        <NavItemWrapper active={props.subTabKey == 'COMPARE-CONVERSION' || props.subTabKey == 'COMPARE-VOLUME'} href={hrefPrefix + '/dash-board/compare-conversion'}>
                            Comparison
                        </NavItemWrapper>

                        <li role='presentation'><span>|</span></li>

                        <NavItemWrapper active={props.subTabKey == 'NETWORK-FIVE-STAR-SURVEYS'} href={hrefPrefix + '/dash-board/network-five-star-surveys'}>
                            Donor Satisfaction Survey Results (Network)
                        </NavItemWrapper>

                        <li role='presentation'><span>|</span></li>

                        <NavItemWrapper active={props.subTabKey == 'PWL-LABBILLING'
                            || props.subTabKey == 'PWL-JUGBILLING'
                        } href={hrefPrefix + '/dash-board/pwl-labbilling'}>
                            PWL
                        </NavItemWrapper>
                    </Nav>
                </div>
            )}

            {props.tabKey == 'ALL-CENTERS' && (
                <div style={{ padding: '20px 10px', backgroundColor: 'white' }}>
                    <Nav bsStyle='pills' className='center-pills'>
                        <NavItemWrapper active={props.subTabKey == 'DIRECTORY' || props.subTabKey == 'CENTER-SPECIFIC'} href={hrefPrefix + `/all-centers`}>
                            Directory
                        </NavItemWrapper>

                        <li role='presentation' className='divider'><span>|</span></li>

                        <NavItemWrapper active={props.subTabKey == 'COMPLIANCE'} href={`center/${props.id?props.id:0}/reports/all-centers/compliance`}>
                            Compliance
                        </NavItemWrapper>

                        <li role='presentation' className='divider'><span>|</span></li>

                        <NavItemWrapper active={props.subTabKey == 'PRESELECT-HISTORY'} href={hrefPrefix + '/all-centers/preselect-history'}>
                            Preselect History
                        </NavItemWrapper>

                        <li role='presentation' className='divider'><span>|</span></li>

                        <NavItemWrapper active={props.subTabKey == 'TRANSPLANTED-PATIENTS'} href={hrefPrefix + `/all-centers/transplanted-patients`}>
                            Transplants
                        </NavItemWrapper>

                        {/* <li role='presentation' className='divider'><span>|</span></li>

                        <NavItemWrapper active={props.subTabKey == 'VXM-ANALYSIS'} href={hrefPrefix + '/all-centers/vxm-analysis'}>
                            VXM Analysis
                        </NavItemWrapper> */}

                        <li role='presentation' className='divider'><span>|</span></li>

                        <NavItemWrapper active={props.subTabKey == 'CHAIN-END-DECLINE-RATIO'} href={hrefPrefix + '/all-centers/chain-end-decline-ratio'}>
                            CE Decline Ratio
                        </NavItemWrapper>

                        <li role='presentation' className='divider'><span>|</span></li>

                        <NavItemWrapper active={props.subTabKey == 'CHAIN-END-OFFERS'} href={hrefPrefix + '/all-centers/chain-end-offers'}>
                            CE Offers L 12 Mo.
                        </NavItemWrapper>

                        <li role='presentation' className='divider'><span>|</span></li>

                        <NavItemWrapper active={props.subTabKey == 'NKR-DONOR-REFERRAL-CONVERSION-RATE'} href={hrefPrefix + '/all-centers/nkr-donor-referral-conversion-rate'}>
                            NKR Donor Ref. Conv. Rate ({moment().year()})
                        </NavItemWrapper>

                        <li role='presentation'><span>|</span></li>

                        <NavItemWrapper active={props.subTabKey == 'RELATIVE-PERFORMANCE'} href={hrefPrefix + '/all-centers/relative-performance'}>
                            Relative Performance
                        </NavItemWrapper>

                        <li role='presentation'><span>|</span></li>

                        <NavItemWrapper active={props.subTabKey == 'MISSED-MATCH-OFFERS'} href={hrefPrefix + '/all-centers/missed-match-offers'}>
                            Missed MO/XM Deadline L 90 Days
                        </NavItemWrapper>

                        <li role='presentation'><span>|</span></li>

                        <NavItemWrapper active={props.subTabKey == 'CPR'} href={hrefPrefix + '/all-centers/cpr'}>
                            Center CPR Scores
                        </NavItemWrapper>
                    </Nav>
                </div>
            )}


        </NavWrapper>
    );
}

export default AdminReportsNav;